export default "__VITE_ASSET__f7888110__"